import {
  GridColDef,
  GridColumnHeaderParams,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import ToolIcon from "../../../../Common/components/ToolIcon/ToolIcon";
import { IconSize } from "../../../../Common/models/iconSize";
import * as React from "react";
import { Tooltip } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import styles from "./ProjectCostGrid.module.scss";
import { costValueFormat } from "../../../../Common/utils/costValueFormat";
export const getProjectCostColumns = (
  licenseModels: string[]
): GridColDef[] => {
  return [
    {
      field: "capabilityToolKey",
      headerName: "",
      disableColumnMenu: true,
      sortable: false,
      flex: 0.2,
      renderCell: (params: GridRenderCellParams<string>) => {
        return (
          <>
            <ToolIcon
              tool={params.row.capabilityToolKey}
              size={IconSize.Medium}
              tooltipTitle={params.row.toolName}
            />
          </>
        );
      },
    },
    {
      field: "toolName",
      headerName: "Tool name",
      disableColumnMenu: true,
      flex: 2,
      renderCell: (params: GridRenderCellParams<string>) => {
        return <>{`${params.row.toolDisplayName ?? params.row.toolName}`}</>;
      },
    },
    {
      field: "cost",
      headerName: "Cost",
      disableColumnMenu: true,
      flex: 0.8,
      renderCell: (params: GridRenderCellParams<string>) => {
        const cost = params.row.cost;
        return (
          <>
            {params.row.cost === 0 ? "Free of charge" : costValueFormat(cost)}
          </>
        );
      },
    },

    {
      field: "licenseMode",
      headerName: "Licence model",
      flex: 0.9,
      align: "left",
      disableColumnMenu: true,
      renderHeader: (params: GridColumnHeaderParams) => (
        <>
          <strong>{"Licence model"}</strong>
          <Tooltip
            title={
              <>
                Every tool has it’s own license model:
                <ul>
                  {licenseModels.map((licenceModel) => (
                    <li>{licenceModel}</li>
                  ))}
                </ul>
              </>
            }
            arrow
          >
            <InfoOutlined fontSize="small" color={"action"} />
          </Tooltip>
        </>
      ),
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 180,
      disableColumnMenu: true,
    },
    {
      field: "totalCost",
      headerAlign: "right",
      headerName: "Total Cost",
      width: 180,
      align: "right",
      disableColumnMenu: true,
      renderHeader: (params: GridColumnHeaderParams) => (
        <div style={{ paddingRight: "16px" }}>
          <strong>Total cost</strong>
        </div>
      ),
      renderCell: (params: GridRenderCellParams<string>) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "4px", justifyContent: "flex-end", width: "100%" }}>
            {costValueFormat(params.row.totalCost)}
            {params.row.totalCostDescription && (
              <Tooltip title={params.row.totalCostDescription} arrow>
                <InfoOutlined fontSize="small" color="action" />
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];
};

export const getTemporaryLicenseCostColumns = (): GridColDef[] => {
  return [
    {
      field: "userName",
      headerName: "User",
      flex: 1.5,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams<string>) => {
        return <>{params.row.userName || params.row.userEmail}</>;
      },
    },
    {
      field: "toolName",
      headerName: "Tool",
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "capability",
      headerName: "Capability",
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "totalAccessDurationHours",
      headerName: "Access Duration (hours)",
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams<number>) => {
        return <>{params.row.totalAccessDurationHours.toFixed(2)}</>;
      },
    },
    {
      field: "isStillActive",
      headerName: "Status",
      flex: 0.7,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams<boolean>) => {
        return <>{params.row.isStillActive ? "Active" : "Revoked"}</>;
      },
    },
    {
      field: "totalCost",
      headerAlign: "right",
      headerName: "Cost",
      flex: 0.8,
      align: "right",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams<string>) => {
        return <>{costValueFormat(params.row.totalCost)}</>;
      },
    },
  ];
};
